module.exports = __webpack_public_path__ + "static/media/mypage.84f7afdd.svg";